import Layout from "layouts/Layout";
import Auth from "modules/Auth/Middleware/Auth";
import TenantsContent from "modules/Tenants";

import React from "react";
import { setTitle } from "utilities/helper/setTitle";

const TenantsPage: React.FC = () => {
  setTitle("Tenant Management");
  return (
    <Auth>
      <Layout>
        <TenantsContent />
      </Layout>
    </Auth>
  );
};

export default TenantsPage;
